/* import __COLOCATED_TEMPLATE__ from './selectable-user-cell.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();